import { render, staticRenderFns } from "./SelectionCreationNewAccount.vue?vue&type=template&id=471a7c32&scoped=true"
import script from "./SelectionCreationNewAccount.vue?vue&type=script&lang=js"
export * from "./SelectionCreationNewAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471a7c32",
  null
  
)

export default component.exports